import { render, staticRenderFns } from "./selectEdit.vue?vue&type=template&id=2173a9e6&scoped=true&"
import script from "./selectEdit.vue?vue&type=script&lang=js&"
export * from "./selectEdit.vue?vue&type=script&lang=js&"
import style0 from "./selectEdit.vue?vue&type=style&index=0&id=2173a9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173a9e6",
  null
  
)

export default component.exports